import { NumberFormatProps } from "react-number-format";

export const percentageFormat: NumberFormatProps = {
  decimalScale: 3,
  displayType: "text",
  suffix: "%",
};

export const amountFormat = (value: number): NumberFormatProps => ({
  prefix: "CHF ",
  thousandSeparator: value >= 10000 ? " " : undefined,
  decimalScale: 0,
  allowLeadingZeros: false,
  allowNegative: false,
});

export const nivoColors = [
  "blue.650",
  "blue.250",
  "blue.300",
  "blue.200",
  "blue.100",
];
